<template>
  <div
    class="auth-layout"
    style="animation-duration: 0.7s"
  >
    <header-component />
    <div class="middle-wrapper">
      <aside-component v-if="userHasCompletedTypeData" />
      <main :class="mobileMenuIsOpen ? 'mobile-menu-open' : ''">
        <div class="container-fluid">
          <page-loader
            v-if="!showRouterView"
          />
          <div
            v-show="showRouterView"
            class="container main-container"
          >
            <transition
              name="fade"
              @before-leave="makeAbsolute"
            >
              <router-view />
            </transition>
          </div>
        </div>
      </main>
    </div>
    <footer-component />
  </div>
</template>

<script>
import HeaderComponent from './../../components/Header.vue'
import FooterComponent from './../../components/Footer.vue'
import AsideComponent from './../../components/Aside.vue'

export default {
  components: {
    'header-component': HeaderComponent,
    'aside-component': AsideComponent,
    'footer-component': FooterComponent
  },
  data () {
    return {
      showRouterView: false,
      getUnreadMessagesTimeout: null
    }
  },
  computed: {
    userHasCompletedTypeData (newValue, oldValue) {
      return this.$store.getters['user/hasCompletedTypeData']
    },
    mobileMenuIsOpen () {
      return this.$store.state.mobileMenu.isOpen
    }
  },
  mounted () {
    setTimeout(() => {
      this.showRouterView = true
    }, 600)

    this.getUnreadMessages()
  },
  beforeDestroy () {
    if (this.getUnreadMessagesTimeout) {
      clearTimeout(this.getUnreadMessagesTimeout)
    }
  },
  methods: {
    getUnreadMessages () {
      this.getUnreadMessagesTimeout = setTimeout(() => {
        this.$store.dispatch('campaignsMessages/getUnread')
        this.getUnreadMessages()
      }, 6000)
    }
  }
}
</script>

<style lang="scss">
.auth-layout {
  display:flex;
  flex-direction:column;
  min-height: 100vh;
  .middle-wrapper {
    margin-top: 83px;
    display: flex;
    flex-grow: 2;
    background-color: #fafbfd;
    position: relative;
    @include media-breakpoint-down(sm) {
        margin-top: initial;
    }
    aside {
        width: 200px;
    }
    main {
        flex-grow: 2;
        & > .container-fluid > .container {
            max-width: 1076px;
            padding: 2rem;
        }
        @include media-breakpoint-down(sm) {
            &.mobile-menu-open {
                position: absolute;
                top: 0;
                bottom: 0;
                left: 0;
                right: 0;
                overflow: hidden;
                z-index: 0;
                &:after {
                    content: '';
                    position: absolute;
                    top: 0;
                    bottom: 0;
                    left: 0;
                    right: 0;
                    background-color: black;
                    opacity: 0.4;
                }
            }
        }
    }
  }
  .main-container {
    @include media-breakpoint-down(sm) {
      padding-left: 0.5rem !important;
      padding-right: 0.5rem !important;
    }
  }

  $formFontSize: 0.938rem;
  $formSelectItemsFontSize: 0.813rem;
  .select-item-font {
    font-size: $formSelectItemsFontSize;
  }
  .form-font {
    font-size: $formFontSize;
  }
  .label-title {
    font-weight: 500;
    font-size: $formFontSize;
    margin-bottom: 0.5rem;
  }
  label {
    font-weight: 500;
    font-size: $formFontSize;
  }
  .form-group label {
    font-size: $formFontSize;
  }
  .multiselect__single {
    font-size: $formFontSize !important;
  }
  .multiselect__tag {
    font-size: $formFontSize !important;
  }
  .multiselect input {
    font-size: $formFontSize;
  }
  .multiselect input {
    font-size: $formFontSize !important;
  }
  .multiselect__placeholder {
    font-size: $formFontSize !important;
  }
  .multiselect__option {
    font-size: $formFontSize !important;
  }
  .form-control {
    font-size: $formFontSize;
  }
  .custom-select {
    font-size: $formFontSize;
  }

  .w-option-3 {
    width: 32%;
    @include media-breakpoint-down(xs) {
      width: 100%;
      margin-right: 0;
      margin-bottom: 0.5rem;
    }
  }
}
</style>
